module.exports = __webpack_public_path__ + "static/media/digmentha-ability.147a7910.svg";